module.exports = __webpack_public_path__ + "static/media/downloadFullLog.89d3faf2.png";